import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { chatFeatureKey } from '../key';
import type { GetChatroomsQueryFilter } from './useGetChatrooms';

type ChatroomsListQueryType = GenericListQueryKey<GetChatroomsQueryFilter>;

export const getChatroomsListQueryKey = (params: ChatroomsListQueryType) =>
  generateListQueryKey({
    prefix: chatFeatureKey,
  })(params);

export const getChatroomsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getChatroomsListQueryKey,
});
